import { render } from "./PortalSettingsAddBoardMember.vue?vue&type=template&id=0f34d271&scoped=true"
import script from "./PortalSettingsAddBoardMember.vue?vue&type=script&lang=js"
export * from "./PortalSettingsAddBoardMember.vue?vue&type=script&lang=js"

import "./PortalSettingsAddBoardMember.vue?vue&type=style&index=0&id=0f34d271&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f34d271"]])

export default __exports__